var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9092 17L21.9092 12M21.9092 12L16.9092 7M21.9092 12H9.90918M12.9092 17C12.9092 17.93 12.9092 18.395 12.807 18.7765C12.5296 19.8117 11.7209 20.6204 10.6856 20.8978C10.3041 21 9.83915 21 8.90918 21H8.40918C7.01136 21 6.31244 21 5.76113 20.7716C5.02605 20.4672 4.44202 19.8831 4.13754 19.1481C3.90918 18.5967 3.90918 17.8978 3.90918 16.5V7.5C3.90918 6.10217 3.90918 5.40326 4.13754 4.85195C4.44202 4.11687 5.02605 3.53284 5.76113 3.22836C6.31244 3 7.01136 3 8.40918 3H8.90918C9.83915 3 10.3041 3 10.6856 3.10222C11.7209 3.37962 12.5296 4.18827 12.807 5.22354C12.9092 5.60504 12.9092 6.07003 12.9092 7",
    stroke: "#5C6469",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.776b4814d7356647433763fea8ae34b0.svg";
export { ForwardRef as ReactComponent };